'use client';

import type { AuthenticatedUserResponse } from '@govinity/validation';
import { useTranslations } from 'next-intl';
import { LOGO_URL, NEW_FULL_LOGO_URL_DARK } from '@/lib/constants/logo';
import { env } from '@/env.mjs';
import { useLiveMeetingNavStore } from '@/stores/liveMeetingNavStore';
import { LOGIN_URL } from './constants';
import { NavbarUserAvatar } from './navbar-user-avatar';
import { PublicNavbar } from './public-navbar';

export const NavbarWrapper = ({ user }: { user: AuthenticatedUserResponse | null }) => {
  const t = useTranslations('NavbarWrapper');
  const liveMeeting = useLiveMeetingNavStore((state) => state.liveMeeting);

  return (
    <PublicNavbar
      liveMeeting={liveMeeting}
      logo={{
        url: user ? '/account' : '/',
        alt: t('logoAlt'),
        variant: 'full',
        icon: LOGO_URL,
        title: t('logoTitle'),
        lightLogo: NEW_FULL_LOGO_URL_DARK,
        darkLogo: NEW_FULL_LOGO_URL_DARK,
      }}
      menu={[]}
      auth={{
        logout: {
          text: t('logoutText'),
          url: `${env.NEXT_PUBLIC_USER_API_URL}/auth/logout?skip-login-redirect=true`,
        },
        showUserNav: !!user,
        ...(!user && {
          login: { text: t('loginText'), url: LOGIN_URL },
          signup: { text: t('signupText'), url: LOGIN_URL },
        }),
        settingsUrl: '/account/settings',
        userMenuLabel: t('userMenuLabel'),
        showAccount: !!user,
        governmentPortalUrl:
          user && 'governmentId' in user ? env.NEXT_PUBLIC_INTERNAL_CLIENT_URL : undefined,
      }}
      userAvatarSlot={user ? <NavbarUserAvatar user={user} /> : null}
      showThemeToggle={env.NEXT_PUBLIC_APP_ENV === 'development'}
    />
  );
};
